import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { Section } from '../common/Section';
import { path } from '../paths';
import { Classifiers } from './classifier/Classifiers';
import { SectionObject } from '../common/types';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './DataDictionary.translations.json';
import { NotFound } from './NotFound';
import { ClassifierMappings } from './classifier-mapping/ClassifierMappings';
import { OutputDataObjects } from './output-data-objects/OutputDataObjects';
import { InputDataObjects } from './input-data-object/InputDataObjects';

const { addTranslations, Translation } = i18nNsFactory('data-dictionary');
addTranslations(translations);

const dataDictionarySections: SectionObject[] = [
  {
    key: 'classifiers',
    id: 'classifiers-menu-item',
    label: <Translation>{(t) => t('menu.classifiers')}</Translation>,
    route: {
      path: path.classifierDirectory + '/*',
      element: <Classifiers basePath={path.classifierDirectory} />,
    },
  },
  {
    key: 'classifier-mappings',
    id: 'classifier-mappings-menu-item',
    label: <Translation>{(t) => t('menu.classifier-mappings')}</Translation>,
    route: {
      path: path.classifierMappingDirectory + '/*',
      element: (
        <ClassifierMappings basePath={path.classifierMappingDirectory} />
      ),
    },
  },
  {
    key: 'input-data-objects',
    id: 'input-data-objects-menu-item',
    label: <Translation>{(t) => t('menu.input-data-objects')}</Translation>,
    route: {
      path: path.inputDataObjectDirectory + `/*`,
      element: <InputDataObjects basePath={path.inputDataObjectDirectory} />,
    },
  },
  {
    key: 'output-data-objects',
    id: 'output-data-objects-menu-item',
    label: <Translation>{(t) => t('menu.output-data-objects')}</Translation>,
    route: {
      path: path.outputDataObjectDirectory + `/*`,
      element: <OutputDataObjects basePath={path.outputDataObjectDirectory} />,
    },
  },
  {
    key: 'redirect-to-first-section',
    id: 'redirect-to-first-section-menu-item',
    route: {
      path: '/',
      element: <Navigate to="classifiers" replace />,
    },
    hiddenFromMenu: true,
  },
  {
    key: 'not-found',
    id: 'not-found-menu-item',
    route: {
      path: '*',
      element: <NotFound />,
    },
    hiddenFromMenu: true,
  },
];

export interface DataDictionaryProps {
  basePath?: string;
}

export const DataDictionary: FC<DataDictionaryProps> = ({ basePath = '' }) => (
  <Section sections={dataDictionarySections} basePath={basePath} />
);
